import PropTypes from "prop-types";
import React from "react";
import ImmutablePropTypes from "react-immutable-proptypes";

import FormButton from "../form/FormButton";
import InspectorField from "./InspectorField";
import InspectorFooter from "./InspectorFooter";
import InspectorRow from "./InspectorRow";

const InspectorBottomBox = props => {
  return (
    <InspectorFooter>
      <InspectorRow>
        <InspectorField style={{ textAlign: "center" }}>
          <FormButton
            label={props.deleteLabel ? props.deleteLabel : "Delete"}
            destructive={true}
            onClick={() => props.onDeleteItems(props.itemIds.toArray())}
            tooltip={props.tooltip}
          />
        </InspectorField>
      </InspectorRow>
    </InspectorFooter>
  );
};

InspectorBottomBox.propTypes = {
  // Incoming data from parent element
  itemIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  deleteLabel: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  // Dispatch actions
  onDeleteItems: PropTypes.func.isRequired
};

export default InspectorBottomBox;
